import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

interface IStreamState {
  channels: Array<string>;
}

const initialState: IStreamState = {
  channels: [],
};

// `channels` are threads that are subscribed
// Basically, channels will only ever be either empty or the current thread.
//
const streamSlice = createSlice({
  name: 'stream',
  initialState,
  reducers: {
    unsubscribe: (state, { payload }: PayloadAction<string | undefined>) => {
      if (payload) {
        state.channels = state.channels.filter((channel) => channel !== payload);
        return state;
      }
      state.channels = [];
      return state;
    },
    subscribe: (state, { payload }: PayloadAction<string>) => {
      if (!state.channels.includes(payload)) {
        state.channels.push(payload);
      }
    },
  },
});

export const selectChannels = (state: RootState) => state.stream.channels;

export const { subscribe, unsubscribe } = streamSlice.actions;
export default streamSlice.reducer;
